import { useState, type FormEvent } from 'react';

import { changePassword } from '../../api/auth';
import { ApiError } from '../../api/client';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { NewPasswordFields, newPasswordProblem } from './NewPasswordFields';

/** Current password + new password ×2. Used by the forced-change screen and by «Мой доступ». */
export function ChangePasswordForm({
  email,
  currentLabel = 'Текущий пароль',
  submitLabel = 'Сменить пароль',
  onChanged,
}: {
  email?: string | null;
  currentLabel?: string;
  submitLabel?: string;
  onChanged?: (endedSessions: number) => void;
}) {
  const [current, setCurrent] = useState('');
  const [pw, setPw] = useState({ password: '', repeat: '' });
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sameAsCurrent = pw.password.length > 0 && pw.password === current ? 'Новый пароль должен отличаться от текущего' : null;
  const complete = current.length > 0 && !newPasswordProblem(pw, email) && !sameAsCurrent;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!complete) return;
    setPending(true);
    setError(null);
    try {
      const res = await changePassword(current, pw.password);
      setCurrent('');
      setPw({ password: '', repeat: '' });
      onChanged?.(res.ended_sessions);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось сменить пароль. Попробуйте ещё раз.');
    } finally {
      setPending(false);
    }
  }

  return (
    <form onSubmit={(e) => void handleSubmit(e)}>
      <label className="mb-3 block text-sm" htmlFor="pw-current">
        {currentLabel}
        <Input
          id="pw-current"
          className="mt-1"
          type="password"
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          required
        />
      </label>
      <NewPasswordFields idPrefix="pw" value={pw} onChange={setPw} email={email} extraProblem={sameAsCurrent} />
      {error && (
        <p role="alert" className="mb-3 text-sm text-red-600">
          {error}
        </p>
      )}
      <Button type="submit" disabled={pending || !complete}>
        {pending ? 'Сохраняем…' : submitLabel}
      </Button>
    </form>
  );
}
